/**
 * @param  {...string} args - multiple strings to combine into one. first string is the join string
 * @returns joined string
 */
export const stringCombine = (...args) => {//REVIEW: seperate function is not required. same can be achieved using join operation of array.
  //min 3 args, join string, pre and post strings
  if (!args || args.length < 3) {
    throw new Error("Incorrect no of arguments for string comnbiner");
  }

  return args.splice(1).join(args[0]);
};

export const simpleStringEncode = (string) => {
  // return atob(string);
  return string;
};

export const simpleStringDecode = (string) => {
  // return btoa(string);
  return string;
};
export const TimezoneList = [
  "AKST",
  "PST",
  "CST",
  "EST",
  "MT",
  "MDT",
  "AST",
  "HST",
  "NST",
];
